import * as api from 'Shared/api/workspacePrivateNote';
import { showNotificationError } from 'Shared/helpers';

export const clearWorkspacePrivateNoteAction = () => async dispatch => {
  dispatch({ type: 'CLEAR_WORKSPACE_PRIVATE_NOTE' });
};

export const getWorkspacePrivateNoteAction = ({ userId, workspaceId }) => async dispatch => {
  try {
    const response = await api.getWorkspacePrivateNote({ userId, workspaceId });
    if (response && response.status === 200) {
      dispatch({ type: 'GET_WORKSPACE_PRIVATE_NOTE_RESPONSE', payload: { workspacePrivateNote: response.data.data } });
    }
    return response;
  } catch (e) {
    clearWorkspacePrivateNoteAction();
    return showNotificationError(e);
  }
};

export const createOrUpdateWorkspacePrivateNoteAction = ({ text, workspaceId }) => async dispatch => {
  try {
    const response = await api.createOrUpdateWorkspacePrivateNote({ text, workspaceId });
    if (response && response.status === 200) {
      dispatch({
        type: 'UPDATE_WORKSPACE_PRIVATE_NOTE_RESPONSE',
        payload: { workspacePrivateNote: response.data.data },
      });
    }
    return response;
  } catch (e) {
    return showNotificationError(e);
  }
};
